import { render, staticRenderFns } from "./profile-layout.vue?vue&type=template&id=c99bfa52&"
import script from "./profile-layout.vue?vue&type=script&lang=ts&"
export * from "./profile-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports